import { variant } from 'styled-system';

import { theme } from '../../../common/ui/theme';
import { buttonShadows } from '../components/buttonShadows';

export function getDefaultEmphasisVariant() {
    return variant({
        prop: 'emphasis',
        variants: {
            high: {
                color: theme.colors.foreground.onEmphasis,
                background: `linear-gradient(0deg, ${theme.colors.accent.emphasis}, ${theme.colors.accent.emphasis}, ${theme.colors.effects.accentGradientStop})`,
                borderStyle: 'none',
                backgroundSize: '200% 200%',
                backgroundPosition: '0% 0%',
                transition: 'background-position 100ms ease-out',
                padding: '4px 8px',
                boxShadow: `${buttonShadows.emphDrop}, ${buttonShadows.emphBorder}`,

                '&:hover': {
                    backgroundPosition: '100% 100%',
                    boxShadow: `${buttonShadows.emphDrop},
                        ${buttonShadows.emphBorderHover},
                        ${buttonShadows.dropHover}`,
                },
                '&:focus': {
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.emphDrop},
                        ${buttonShadows.emphBorderHover},
                        ${buttonShadows.dropHover}`,
                },
                '&:active': {
                    background: theme.colors.accent.foreground,
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.emphDrop},
                        ${buttonShadows.emphBorderHover},
                        ${buttonShadows.dropHover}`,
                },
                '&:disabled': {
                    background: theme.colors.accent.border,
                    boxShadow: `${buttonShadows.emphBorderDisabled}`,
                },
            },
            medium: {
                color: theme.colors.foreground.default,
                background: `linear-gradient(0deg, ${theme.colors.background.subtle}, ${theme.colors.background.subtle}, ${theme.colors.background.default})`,
                boxShadow: `${buttonShadows.drop} ,${theme.shadows.border.default}`,
                padding: '4px 8px',
                backgroundSize: '200% 200%',
                backgroundPosition: '0% 0%',
                transition: 'background-position 100ms ease-out, box-shadow 100ms ease-in-out',

                '&:hover': {
                    backgroundPosition: '100% 100%',
                    boxShadow: `${buttonShadows.drop}, ${buttonShadows.borderHover}, ${buttonShadows.dropHover}`,
                },
                '&:focus': {
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.drop},
                        ${buttonShadows.borderHover},
                        ${buttonShadows.dropHover}`,
                },
                '&:active': {
                    background: theme.colors.background.inset,
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.drop},
                        ${theme.shadows.border},
                        ${buttonShadows.dropHover}`,
                },
            },
            low: {
                color: theme.colors.accent.foreground,
                background: 'transparent',
                borderStyle: 'none',
                padding: '4px 8px',

                '&:hover': {
                    background: theme.colors.background.subtle,
                },
                '&:focus': {
                    background: theme.colors.background.subtle,
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.drop},
                        ${buttonShadows.borderHover},
                        ${buttonShadows.dropHover}`,
                },
                '&:active': {
                    background: theme.colors.background.inset,
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.drop},
                        ${theme.shadows.border},
                        ${buttonShadows.dropHover}`,
                },
            },
            none: {
                color: theme.colors.foreground.default,
                background: 'transparent',
                borderStyle: 'none',
                padding: '4px 8px',

                '&:hover': {
                    background: theme.colors.background.subtle,
                    color: theme.colors.accent.foreground,
                },
                '&:focus': {
                    background: theme.colors.background.subtle,
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.drop},
                        ${buttonShadows.borderHover},
                        ${buttonShadows.dropHover}`,
                },
                '&:active': {
                    background: theme.colors.background.inset,
                    color: theme.colors.accent.foreground,
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.drop},
                        ${theme.shadows.border},
                        ${buttonShadows.dropHover}`,
                },
            },
        },
    });
}
